import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, Col, Container, Row, Table, Label } from 'reactstrap';
import BreadCrumb from '../components/Common/BreadCrumb';

import { createDeepClone } from "../utils/index";

import CardLoader from "../components/CardLoader";
import SortHeaderComponent from "../components/SortHeaderComponent";
import PaginationComponent from "../components/PaginationComponent";
import MySearchOption from "../components/MySearchOption";
import MyDateRenderer from "../components/MyDateRenderer";

import { useDispatch, useSelector } from "react-redux";

import * as labReportAction from "../actions/LabReportAction";

const LabReportSearchScreen  = () => {
    const dispatch = useDispatch();
    
    const loading = useSelector((state) => state.labReport.loading);
    const list = useSelector((state) => state.labReport.list);
    const filter = useSelector((state) => state.labReport.filter);
    const user = useSelector((state) => state.login.user);

    const doSearch = () => {
        var copy_filter = createDeepClone(filter);
        
        if(copy_filter.pageIndex == 1) {
            dispatch(labReportAction.loadLabReportSearch(filter));
        }
        else {
            copy_filter.pageIndex = 1;
            dispatch(labReportAction.setLabReportFilter(copy_filter));
        }
    }

    React.useEffect(() => {
		dispatch(labReportAction.loadLabReportSearch(filter));
    }, [filter.pageIndex, filter.sortBy, filter.sortOrder]);

    const onFilterChange = (name, value) => {
        var copy_filter = createDeepClone(filter);
        copy_filter[name] = value;
        dispatch(labReportAction.setLabReportFilter(copy_filter));
    }

    const onSortChange = (sortBy, sortOrder) => {
        var copy_filter = createDeepClone(filter);
        copy_filter["sortBy"] = sortBy;
        copy_filter["sortOrder"] = sortOrder;
        dispatch(labReportAction.setLabReportFilter(copy_filter));
    }
    
    const onPageChange = (page) => {
        var copy_filter = createDeepClone(filter);
        copy_filter.pageIndex = page;
        dispatch(labReportAction.setLabReportFilter(copy_filter));
    }
    
    return(
        <Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Lab Report Search" />
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody className="border border-dashed border-end-0 border-start-0">
                                    <Row className="gy-3">
                                        <Col xxl={user && user.canEditLabReport ? 4 : 6} md={12}>
                                            <MySearchOption
                                                placeholder={"Search lab reports by test report number, lab name, batch #, lot #, client name or parameters..."}
                                                value={filter.search}
                                                searchList={list.searchList || []}
                                                fieldName="search"
                                                onChange={onFilterChange}
                                            />
                                        </Col>
                                        <Col xxl={2} md={12}>
                                            <input type="text" className="form-control" placeholder="Search by product name..."
                                                value={filter.productName}
                                                onChange={e => onFilterChange("productName", e.target.value)}
                                            />
                                        </Col>
                                        <Col xxl={2} md={12}>
                                            <input type="text" className="form-control" placeholder="Search by brand name..."
                                                value={filter.brandName}
                                                onChange={e => onFilterChange("brandName", e.target.value)}
                                            />
                                        </Col>
                                        <Col xxl={2} md={12}>
                                            <button type="button" className="btn btn-primary btn-label w-100" 
                                                disabled={loading}
                                                onClick= {() => doSearch()}
                                            >
                                                <i className="ri-search-eye-line label-icon align-middle"></i> Search
                                            </button>
                                        </Col>
                                        {user && user.canEditLabReport &&
                                        <Col xxl={2} md={12}>
                                            <Link to={`/lab-report-add`} className="btn btn-primary btn-label w-100">
                                                <i className="ri-add-line label-icon align-middle"></i> Add
                                            </Link>
                                        </Col>
                                        }
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardLoader loading={loading} />
                                <CardBody>
                                    <div className="table-responsive table-card">
                                        <Table className="table-hover align-middle mb-0">
                                            <thead className="table-primary">
                                                <tr>
                                                    <th style={{width:10}}>&nbsp;</th>
                                                    <th><SortHeaderComponent title="Test Report #" column="test_report_number" filter={filter} onSortChange={onSortChange} /></th>
                                                    <th><SortHeaderComponent title="Lab Name" column="lab_name" filter={filter} onSortChange={onSortChange} /></th>
                                                    <th><SortHeaderComponent title="Product Name" column="product_name" filter={filter} onSortChange={onSortChange} /></th>
                                                    <th><SortHeaderComponent title="Brand Name" column="brand_name" filter={filter} onSortChange={onSortChange} /></th>
                                                    <th><SortHeaderComponent title="Batch #" column="batch_num" filter={filter} onSortChange={onSortChange} /></th>
                                                    <th><SortHeaderComponent title="Lot #" column="lot_num" filter={filter} onSortChange={onSortChange} /></th>
                                                    <th><SortHeaderComponent title="Production Date" column="production_date" filter={filter} onSortChange={onSortChange} /></th>
                                                    <th><SortHeaderComponent title="Client Name" column="client_name" filter={filter} onSortChange={onSortChange} /></th>
                                                    <th><SortHeaderComponent title="Report Date" column="report_date" filter={filter} onSortChange={onSortChange} /></th>
                                                    <th><SortHeaderComponent title="Date Added" column="date_added" filter={filter} onSortChange={onSortChange} /></th>
                                                    <th><SortHeaderComponent title="Added By" column="added_by" filter={filter} onSortChange={onSortChange} /></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {list.dataList.map(function(item, index){
                                                    return(
                                                        <tr key={index}>
                                                            <td>
                                                                <div className="flex-shrink-0">
                                                                    <ul className="list-inline tasks-list-menu mb-0">
                                                                        <li className="list-inline-item">
                                                                            <Link to={`/lab-report-edit/${item.id}`}>
                                                                                <i className="ri-pencil-fill fs-20 align-bottom text-primary"></i>
                                                                            </Link>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </td>
                                                            <td>{item.testReportNumber}</td>
                                                            <td>{item.labName}</td>
                                                            <td>{item.productName}</td>
                                                            <td>{item.brandName}</td>
                                                            <td>{item.batchNum}</td>
                                                            <td>{item.lotNum}</td>
                                                            <td><MyDateRenderer value={item.productionDate} format={"mm/dd/yyyy"} /></td>
                                                            <td>{item.clientName}</td>
                                                            <td><MyDateRenderer value={item.reportDate} format={"mm/dd/yyyy"} /></td>
                                                            <td><MyDateRenderer value={item.dateAdded} /></td>
                                                            <td>{item.addedBy}</td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </Table>
                                    </div>
                                    <Row>
                                        <Col lg={12}>
                                            <PaginationComponent
                                                total={list.totalCount}
                                                currentPage={filter.pageIndex}
                                                onPageChange={page => onPageChange(page)}
                                            />
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </Fragment>
    );
}

export default LabReportSearchScreen;